import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Col, FormGroup, Row, Modal, Container } from 'react-bootstrap';
import { cloneDeep, isArray, set } from 'lodash';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Typeahead, asyncContainer } from 'react-bootstrap-typeahead';
import { MultiSelect } from 'react-multi-select-component';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import DamFolderFileCard from '../../../../Components/Card/DamFolderFileCard/DamFolderFileCard';
import { toasterMsg } from '../../../../Components/Toaster/Toaster';
import Loader from '../../../../Components/Utility/Loader/Loader';
import * as action from '../store/DamFolder.action';
import ImgDropzone from '../../../../Components/ImgDropzone/ImgDropzone';
import ConfirmationPopup from '../../../../Components/ModalPopup/ConfirmationPopup';
import ImageSelector from '../../../../Components/ImgDropzone/imageSelector';
import { getBrandDetails, getPCTypesDetails, getMultiSubBrandDetails } from '../../../SystemMasters/Store/SystemMasters.action';

const AsyncTypeahead = asyncContainer(Typeahead);

function AddEditDamFolderGroup({ match }) {
  const typeaheadConfig = useRef(null);
  const editId = match.params.id;
  const devOrderId = match?.params?.devOrderId;
  const [filesOptions, setFilesOptions] = useState([]);
  const { t } = useTranslation('common');
  const history = useHistory();
  const dispatch = useDispatch();
  const childRef = useRef();
  const {
    damFolderData: { damDetails, filesSuggestionList },
    SystemMastersDetails,
    UserDetails: {
      userInfo: { userId },
    },
  } = useSelector((reduxState) => reduxState);

  const { pcTypeList, brandList, multiSubBrandList } = SystemMastersDetails;
  const [suggestionLoader, setsuggestionLoader] = useState(false);
  const [state, setState] = useState({
    damFolderData: {},
    showImageUpload: false,
    showDeleteModal: false,
    errorLog: [],
    isEditMode: false,
    isPageLoad: false,
    filesArray: [],
    allSelectedFolderFiles: [],
    deleteFilesStae: false,
    deleteFileId: null,
    confirmModal: false,
    uncheckFilteredFilesSet: [],
    selectedProductType: [],
    selectedBrand: [],
    seletedMultiKey: null,
  });

  const {
    deleteFileId,
    deleteFilesStae,
    allSelectedFolderFiles,
    damFolderData,
    isEditMode,
    showImageUpload,
    isPageLoad,
    showDeleteModal,
    errorLog,
    filesArray,
    confirmModal,
    uncheckFilteredFilesSet,
    selectedProductType,
    selectedBrand,
    seletedMultiKey,
  } = state;

  const location = useLocation();
  const isDuplicateFolder = location?.state?.isDuplicate || false;
  const isFromDirectAssetModal = location?.state?.isFromDirectAssetModal || false;
  const directCreateFolderProductType = location?.state?.assetProductType || false;
  const directCreateFolderBrand = location?.state?.assetBrand || false;
  const directSelectedFiles = location?.state?.fileIds || false;

  useEffect(() => {
    const callFn = async () => {
      if (directSelectedFiles?.length && isFromDirectAssetModal) {
        const obj = {
          searchText: '',
          productType: directCreateFolderProductType || [],
          isDirectCall: true,
        };
        if (directCreateFolderBrand?.length) {
          obj.brand = directCreateFolderBrand || [];
        }
        await callFilterApi(obj);
      }
    };
    callFn();
  }, [directSelectedFiles?.length, isFromDirectAssetModal]);

  const handleImageUpload = () => {
    setState((prevState) => ({
      ...prevState,
      showImageUpload: true,
    }));
  };

  const handleImageDelete = () => {
    setState((prevState) => ({
      ...prevState,
      showDeleteModal: true,
    }));
  };

  const callFunc = async () => {
    await dispatch(
      getPCTypesDetails({
        loggedInUserId: userId,
        isActive: true,
        tier: 'Tier1',
      }),
    );
    await dispatch(
      getBrandDetails({
        loggedInUserId: userId,
        isActive: 1,
      }),
    );
  };

  useEffect(() => {
    callFunc();
  }, []);

  useEffect(() => {
    const brandIds = JSON.stringify((damFolderData?.brand || []).map((data) => data?._id).sort());
    if (brandIds !== '[]') {
      dispatch(getMultiSubBrandDetails({ brandId: JSON.parse(brandIds) }));
    }
  }, [JSON.stringify((damFolderData?.brand || []).map((data) => data?._id).sort()), dispatch]);

  useEffect(() => {
    if (damFolderData?.brand?.length > 0) {
      const brandIds = JSON.stringify((damFolderData?.brand || []).map((data) => data?._id));
      dispatch(getMultiSubBrandDetails({ brandId: JSON.parse(brandIds) }));
    }
  }, [damDetails?.brand]);

  useEffect(() => {
    return () => {
      dispatch(action.unmountDamFolderData());
      setState((prevState) => ({
        ...prevState,
        isEditMode: false,
        damFolderData: {},
      }));
    };
  }, []);

  const groupOptions = (option) => {
    return option?.assetTitle;
  };

  const callFilterApi = async (obj) => {
    await dispatch(action.fetchFilesSuggestion(obj));
  };

  const promiseSearch = async (inputValue) => {
    if (inputValue?.trim()?.length) {
      setsuggestionLoader((prev) => !prev);
      const obj = {
        searchText: inputValue,
        productType: damFolderData?.productType?.map((data) => data?._id) || [],
      };
      if (damFolderData?.brand) {
        obj.brand = damFolderData?.brand?.map((data) => data?._id) || [];
      }
      await callFilterApi(obj);
      setsuggestionLoader((prev) => !prev);
    }
  };

  const pcTypeOptions = useMemo(() => {
    if (isArray(pcTypeList) && pcTypeList?.length > 0) {
      return pcTypeList.map((option) => ({ ...option, label: option?.name, value: option?._id }));
    }
    return [];
  }, [pcTypeList?.length]);

  const brandOptions = useMemo(() => {
    if (isArray(brandList) && brandList?.length > 0) {
      return brandList.map((option) => ({ ...option, label: option?.name, value: option?._id }));
    }
    return [];
  }, [brandList?.length]);

  const subBrandOptions = useMemo(() => {
    if (!isArray(multiSubBrandList) || !multiSubBrandList?.length) {
      return [];
    }
    if (!damFolderData?.brand?.length) {
      return [];
    }
    const selectedBrandIds = damFolderData.brand.map((brand) => brand.value);
    return multiSubBrandList
      .filter((option) => selectedBrandIds.includes(option.brandId))
      .map((option) => ({
        ...option,
        label: option?.name,
        value: option?._id,
      }));
  }, [multiSubBrandList, damFolderData?.brand]);

  useEffect(() => {
    setFilesOptions(filesSuggestionList);
  }, [filesSuggestionList?.length]);

  useEffect(() => {
    if (isFromDirectAssetModal && filesSuggestionList.length) {
      setFilesOptions(filesSuggestionList);
      const filesToList = filesSuggestionList.filter((vl) => directSelectedFiles?.includes(vl._id));
      const damFolderData = {
        brand: directCreateFolderBrand?.map((brandId) => brandOptions.find((option) => option._id === brandId) || null).filter(Boolean), // Removes null/undefined values
        productType: directCreateFolderProductType?.map((typeId) => pcTypeOptions.find((option) => option._id === typeId) || null).filter(Boolean),
      };
      setState((prevState) => ({
        ...prevState,
        filesArray: filesToList,
        damFolderData,
      }));
    }
  }, [isFromDirectAssetModal, filesSuggestionList.length, pcTypeOptions?.length, brandOptions?.length]);

  useEffect(() => {
    return () => {
      setFilesOptions([]);
    };
  }, []);

  const filterByGroup = (option, props) => {
    const name = option?.assetTitle ? option?.assetTitle?.toLowerCase() : '';
    const search = (props?.text || '')?.trim().toLowerCase();
    return name.includes(search);
  };

  const confirmDeleteImage = async () => {
    const copyState = cloneDeep(damFolderData);
    if (copyState?.image && editId) {
      const res = await dispatch(action.deleteFolderImage(editId, t));
      if (res?.code === 200) {
        set(copyState, 'image', '');
        set(copyState, 'fullImage', '');
        setState((prevData) => ({
          ...prevData,
          showDeleteModal: false,
          damFolderData: copyState,
        }));
      } else {
        setState((prevData) => ({
          ...prevData,
          showDeleteModal: false,
        }));
      }
    }
  };

  const closeModal = () => {
    setState((prevState) => ({
      ...prevState,
      showDeleteModal: false,
    }));
  };

  const closeDeletFileModal = () => {
    setState((prevState) => ({
      ...prevState,
      deleteFileId: null,
      deleteFilesStae: false,
    }));
  };

  const handleInputSelect = (value, key) => {
    const cloneData = cloneDeep(damFolderData);
    cloneData[key] = value;
    setState((prevState) => ({
      ...prevState,
      damFolderData: cloneData,
    }));
  };

  const handleInputBlur = (value, key) => {
    let errorLogKeyList = [];
    if (key === 'name' && value.trim() !== '') {
      errorLogKeyList = errorLog.filter((item) => item !== 'name');
    }
    const cloneData = cloneDeep(damFolderData);
    cloneData[key] = value.trim();
    setState((prevState) => ({
      ...prevState,
      damFolderData: cloneData,
      errorLog: errorLogKeyList,
    }));
  };

  const handleSubmitUpload = async (type) => {
    if (type !== 'close') {
      const croppedFileUrl = await childRef.current.showCroppedImg();

      if (croppedFileUrl) {
        const { imageRes, originalImg } = await croppedFileUrl;
        const orignalImageres = await originalImg;
        const copyState = cloneDeep(damFolderData);
        set(copyState, 'image', imageRes);
        set(copyState, 'fullImage', orignalImageres);
        setState((prevData) => ({
          ...prevData,
          showImageUpload: false,
          damFolderData: copyState,
        }));
      } else {
        toasterMsg(t('SPEC_TEMP_LIBRARY.IMAGE_REQUIRED'), 'danger');
      }
    } else {
      setState((prevData) => ({
        ...prevData,
        showImageUpload: false,
      }));
    }
  };

  const isValid = () => {
    const errorLogKey = [];

    if (!Object.hasOwn(damFolderData, 'name') || damFolderData.name.trim() === '') {
      errorLogKey.push('name');
    }

    if (!damFolderData?.productType?.length) {
      errorLogKey.push('productType');
    }

    setState((prevState) => ({
      ...prevState,
      errorLog: errorLogKey,
    }));
    return errorLogKey?.length <= 0;
  };

  const redirectToListPage = () => {
    history.push('/digital-assets-management/folder', { activeList: 'folder' });
  };

  const saveFolderData = async () => {
    if (isValid()) {
      const updatedData = {
        ...damFolderData,
        files: filesArray?.map((files) => files._id),
        productType: damFolderData?.productType.map((data) => data._id),
        brand: (damFolderData?.brand || []).map((data) => data._id),
        subBrand: (damFolderData?.subBrand || []).map((data) => data._id),
      };

      setState((prevState) => ({
        ...prevState,
        isPageLoad: true,
      }));

      if (isEditMode) {
        updatedData.id = editId;
        if (isDuplicateFolder) {
          const duplicateres = await dispatch(action.duplicateFolder(updatedData, t));
          if (duplicateres) {
            redirectToListPage();
          }
        } else {
          const updateResponse = await dispatch(action.editDamFolder(updatedData, t));
          if (updateResponse) {
            redirectToListPage();
          }
        }
        setState((prevState) => ({
          ...prevState,
          isPageLoad: false,
        }));
      } else {
        const saveResponse = await dispatch(action.addDamFolder(updatedData, t));
        setState((prevState) => ({
          ...prevState,
          isPageLoad: false,
        }));
        if (saveResponse) {
          redirectToListPage();
        }
      }
    }
  };

  useEffect(() => {
    const getFolderDetail = async () => {
      if (editId) {
        setState((prevState) => ({
          ...prevState,
          isPageLoad: true,
        }));
        const params = {
          id: editId,
        };
        await dispatch(action.fetchDamFolderGroupByDetailId(params, t));
        setState((prevState) => ({
          ...prevState,
          isEditMode: true,
          isPageLoad: false,
        }));
      }
    };
    getFolderDetail();
  }, [dispatch, editId, isDuplicateFolder, t]);

  const onSelectCheckBox = async (id) => {
    let selectedItems = [...allSelectedFolderFiles];
    const findItems = selectedItems.filter((item) => item === id);
    if (findItems.length > 0) {
      selectedItems = selectedItems.filter((item) => item !== id);
      setState((prevState) => ({ ...prevState, allSelectedFolderFiles: selectedItems }));
    } else {
      setState((prevState) => ({ ...prevState, allSelectedFolderFiles: [...selectedItems, id] }));
    }
  };

  const onDeleteFiles = async (id) => {
    setState((prevState) => ({
      ...prevState,
      deleteFileId: id,
      deleteFilesStae: true,
    }));
  };

  const deleteFolderFiles = async () => {
    const deleteFileids = allSelectedFolderFiles?.length ? allSelectedFolderFiles : [deleteFileId];
    if (isDuplicateFolder || !editId) {
      const cloneFilesArray = filesArray.filter((item) => !deleteFileids.includes(item._id));
      setState((prevState) => ({ ...prevState, filesArray: cloneFilesArray }));
    } else {
      const res = await dispatch(action.removeFolderFiles(editId, deleteFileids, t));
      if (res.code === 200) {
        const cloneFilesArray = filesArray.filter((item) => !deleteFileids.includes(item._id));
        setState((prevState) => ({ ...prevState, filesArray: cloneFilesArray }));
      }
    }
    closeDeletFileModal();
  };

  const onAutoSuggestion = async (selected) => {
    const typeaheadConfigRef = typeaheadConfig.current;
    if (selected && Array.isArray(selected) && selected[0] && selected[0]._id) {
      let cloneFiles = [...filesArray];
      const existingIndex = cloneFiles?.findIndex((item) => item?._id === selected[0]._id);
      if (existingIndex !== -1 && existingIndex !== undefined) {
        cloneFiles[existingIndex] = selected[0];
        toasterMsg('This assets already exists', 'danger');
      } else if (cloneFiles) {
        cloneFiles.push(selected[0]);
      } else {
        cloneFiles = [selected[0]];
      }

      setState((prevState) => ({
        ...prevState,
        filesArray: cloneFiles,
      }));

      if (typeaheadConfigRef) typeaheadConfigRef.clear();
    }
  };

  const checkFileArray = (fileArray, productTypeIds, brandIds) => {
    return fileArray.filter((file) => {
      let common = false;
      if (file.productTypeIds?.length === 0 && file.brandIds?.length === 0) {
        common = true;
      }
      const filterByProductType = productTypeIds ? file.productTypeIds.some((ptId) => productTypeIds.includes(ptId)) : true;
      const filterByBrand = brandIds ? file.brandIds.some((bId) => brandIds.includes(bId)) : true;
      return common || (filterByProductType && filterByBrand);
    });
  };

  const afterConfirmUnlink = () => {
    const cloneData = cloneDeep(damFolderData);
    if (seletedMultiKey === 'productType') {
      cloneData.productType = selectedProductType;
      setState((prevState) => ({
        ...prevState,
        confirmModal: false,
        uncheckFilteredFilesSet: [],
        filesArray: uncheckFilteredFilesSet,
        selectedBrand: [],
        selectedProductType: [],
        seletedMultiKey: null,
        damFolderData: cloneData,
      }));
    }
    if (seletedMultiKey === 'brand') {
      cloneData.brand = selectedBrand;
      setState((prevState) => ({
        ...prevState,
        confirmModal: false,
        uncheckFilteredFilesSet: [],
        filesArray: uncheckFilteredFilesSet,
        selectedBrand: [],
        selectedProductType: [],
        seletedMultiKey: null,
        damFolderData: cloneData,
      }));
    }
  };
  const handleChange = (value, key) => {
    const typeaheadConfigRef = typeaheadConfig.current;

    if (typeaheadConfigRef) typeaheadConfigRef.clear();
    if (key === 'productType' && filesArray?.length > 0) {
      const previousSelected = damFolderData?.productType?.map((option) => option.value) || [];
      const brands = damFolderData?.brand?.map((option) => option.value) || [];
      const currentSelected = value?.map((option) => option.value);
      if (currentSelected.length < previousSelected.length) {
        const filteredFileList = checkFileArray(filesArray, currentSelected, brands);
        setState((prev) => ({ ...prev, confirmModal: true, uncheckFilteredFilesSet: filteredFileList, selectedProductType: value, seletedMultiKey: key }));
        return;
      }
    }

    if (key === 'brand') {
      const previousSelected = damFolderData?.brand?.map((option) => option.value) || [];
      const currentSelected = value?.map((option) => option.value);
      const cloneData = cloneDeep(damFolderData);

      if (currentSelected.length < previousSelected.length) {
        const removedBrands = previousSelected.filter((brandId) => !currentSelected.includes(brandId));
        if (cloneData.subBrand?.length > 0 && removedBrands.length > 0) {
          cloneData.subBrand = cloneData.subBrand.filter((subBrand) => currentSelected.includes(subBrand.brandId));
        }
      } else {
        // ✅ Reset subBrands to only those matching the new selection
        cloneData.subBrand = cloneData.subBrand?.filter((subBrand) => currentSelected.includes(subBrand.brandId)) || [];
      }

      if (filesArray?.length > 0) {
        const productTypes = damFolderData?.productType?.map((option) => option.value) || [];
        const filteredFileList = checkFileArray(filesArray, productTypes, currentSelected);

        if (filteredFileList?.length !== filesArray?.length) {
          setState((prev) => ({
            ...prev,
            confirmModal: true,
            uncheckFilteredFilesSet: filteredFileList,
            selectedBrand: value,
            seletedMultiKey: key,
            damFolderData: cloneData,
          }));
          return;
        }
      }

      // ✅ Always update state with cleaned subBrand list
      setState((prevState) => ({
        ...prevState,
        damFolderData: {
          ...prevState.damFolderData,
          ...cloneData,
          [key]: value,
        },
      }));
      return;
    }

    // Handle other field changes
    let errorLogKeyList = [];
    if (key === 'productType' && value !== '') {
      errorLogKeyList = errorLog.filter((item) => item !== 'productType');
    }

    setState((prevState) => ({
      ...prevState,
      damFolderData: {
        ...prevState.damFolderData,
        [key]: value,
      },
      errorLog: errorLogKeyList,
    }));
  };

  useEffect(() => {
    if (damDetails) {
      const BrandArray = [];
      const productTypeArray = [];

      if (damDetails?.brand?.length > 0 && brandOptions?.length > 0) {
        damDetails.brand.forEach((id) => {
          const brandData = brandOptions.find((list) => list?._id === id);
          if (brandData) {
            BrandArray.push(brandData); // Only push if found
          } else {
            console.warn(`Brand ID not found: ${id}`);
          }
        });
      }

      if (damDetails?.productType?.length > 0 && pcTypeOptions?.length > 0) {
        damDetails.productType.forEach((id) => {
          const productTypeData = pcTypeOptions.find((list) => list?._id === id);
          if (productTypeData) {
            productTypeArray.push(productTypeData); // Only push if found
          } else {
            console.warn(`Product Type ID not found: ${id}`);
          }
        });
      }

      setState((prevState) => ({
        ...prevState,
        damFolderData: {
          _id: damDetails._id,
          name: damDetails.name,
          image: damDetails.image,
          fullImage: damDetails.fullImage,
          createdAt: damDetails.createdAt,
          modifiedBy: damDetails.modifiedBy,
          brand: BrandArray,
          productType: productTypeArray,
        },
        filesArray: damDetails.files,
      }));
    }
  }, [damDetails, brandOptions, pcTypeOptions]);

  useEffect(() => {
    if (damDetails?.subBrand?.length > 0 && subBrandOptions?.length > 0) {
      const subBrandArray = [];
      damDetails.subBrand.forEach((id) => {
        const subBrandData = subBrandOptions?.find((list) => list?._id === id);
        if (subBrandData) {
          subBrandArray.push(subBrandData);
        }
      });
      setState((prevState) => ({
        ...prevState,
        damFolderData: {
          ...prevState.damFolderData,
          subBrand: subBrandArray,
        },
      }));
    }
  }, [subBrandOptions, damDetails]);

  const closeUnLinkConfirmModal = () => {
    setState((prevState) => ({
      ...prevState,
      confirmModal: false,
      uncheckFilteredFilesSet: [],
      selectedBrand: [],
      selectedProductType: [],
      seletedMultiKey: null,
    }));
  };

  const folderPath = devOrderId ? `/development-order/${devOrderId}/digital-assets-management/folder` : '/digital-assets-management/folder';

  return (
    <>
      <div className="page-title-filter sticky">
        <div className="title-container d-flex align-items-center">
          <h4 className="title">{t('DAM_FOLDER_VIEW.LISTING_VIEW.DIGITAL_ASSET_FOLDER')}</h4>
        </div>
        <div className="search-filter">
          <button type="button" className="btn btn-white btn-back-lib " onClick={saveFolderData}>
            <i className="icon-Save mr-2" />
            {editId && !isDuplicateFolder ? t('DAM_MAIN_VIEW.ADD_EDIT_VIEW.UPDATE_DAM') : t('SPEC_TEMP_LIBRARY.SAVE')}
          </button>

          <Link className="btn btn-white btn-back-lib " to={folderPath}>
            {t('SPEC_TEMP_LIBRARY.BACK')}
          </Link>
        </div>
      </div>
      <Container fluid>
        {isPageLoad ? (
          <Loader />
        ) : (
          <>
            <Row className="my-4 position-relative">
              <Col md={12}>
                <div className="spec-template-form">
                  <ImageSelector
                    data={damFolderData}
                    handleImageUpload={handleImageUpload}
                    handleImageDelete={handleImageDelete}
                    isUploadBtn
                    isDeleteBtn={false}
                    t={t}
                  />
                  <div className="flex-fill px-2">
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <div className="input-group form-floating-label fixed-label">
                            <input
                              type="text"
                              name="name"
                              onChange={(e) => handleInputSelect(e.target.value, 'name')}
                              onBlur={(e) => handleInputBlur(e.target.value, 'name')}
                              value={damFolderData?.name}
                              className="form-control"
                            />
                            <label className="asterisk-req">
                              {t('DAM_FOLDER_VIEW.LISTING_VIEW.FOLDER_NAME')}
                              <span>*</span>
                            </label>
                          </div>
                          {errorLog.includes('name') && <span className="error-message">Folder Name is Required</span>}
                        </FormGroup>
                      </Col>

                      <Col md={3}>
                        <FormGroup>
                          <div className="custom-react-select">
                            <label className="asterisk-req f-13 m-0">
                              {t('DAM_MAIN_VIEW.ADD_EDIT_VIEW.PRODUCT_TYPE')} <span>*</span>
                            </label>
                            <MultiSelect
                              hasSelectAll
                              name="productType"
                              options={pcTypeOptions}
                              className="custom-multiselect"
                              labelledBy={t('DAM_MAIN_VIEW.ADD_EDIT_VIEW.SELECT_PRODUCTS')}
                              value={damFolderData?.productType || []}
                              onChange={(e) => handleChange(e, 'productType')}
                              overrideStrings={{
                                selectSomeItems: t('DAM_MAIN_VIEW.ADD_EDIT_VIEW.SELECT_PRODUCT_TYPE'),
                              }}
                            />
                          </div>
                          {errorLog.includes('productType') && <span className="error-message">Product Type is Required</span>}
                        </FormGroup>
                      </Col>
                      <Col md={3}>
                        <FormGroup>
                          <div className="custom-react-select">
                            <label className="asterisk-req f-13 m-0">{t('DAM_MAIN_VIEW.ADD_EDIT_VIEW.BRAND')}</label>
                            <MultiSelect
                              hasSelectAll
                              name="brand"
                              options={brandOptions}
                              className="custom-multiselect"
                              labelledBy={t('DAM_MAIN_VIEW.ADD_EDIT_VIEW.SELECT_BRAND')}
                              value={damFolderData?.brand || []}
                              onChange={(e) => handleChange(e, 'brand')}
                              overrideStrings={{
                                selectSomeItems: t('DAM_MAIN_VIEW.ADD_EDIT_VIEW.SELECT_BRAND'),
                              }}
                            />
                          </div>
                        </FormGroup>
                      </Col>
                      <Col md={3}>
                        <FormGroup>
                          <div className="custom-react-select">
                            <label className="asterisk-req f-13 m-0">{t('DAM_MAIN_VIEW.ADD_EDIT_VIEW.SUB_BRAND')}</label>
                            <MultiSelect
                              hasSelectAll
                              name="subBrand"
                              options={subBrandOptions?.filter((val) => val?.isActive)}
                              className="custom-multiselect"
                              labelledBy="Select Sub Brand"
                              value={damFolderData?.subBrand || []}
                              onChange={(e) => handleChange(e, 'subBrand')}
                              overrideStrings={{
                                selectSomeItems: 'Select Sub Brand',
                              }}
                            />
                          </div>
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
            </Row>
            {!isFromDirectAssetModal && (
              <div className="search-file-container">
                <form>
                  <AsyncTypeahead
                    disabled={devOrderId}
                    ref={typeaheadConfig}
                    promptText="No Group found"
                    placeholder="Search File"
                    isLoading={suggestionLoader}
                    labelKey="assetTitle"
                    autoFocus
                    filterBy={filterByGroup}
                    onSearch={(query) => promiseSearch(query)}
                    useCache={false}
                    minLength={1}
                    options={filesOptions}
                    onChange={(selected) => onAutoSuggestion(selected)}
                    id="typeheadWithFile"
                    renderMenuItemChildren={(option) => <div key={option?._id}>{groupOptions(option)}</div>}
                  />
                </form>
                {damDetails?.files?.length > 0 && (
                  <button
                    className="btn btn-outline"
                    type="submit"
                    aria-label="Delete"
                    title="Delete"
                    disabled={allSelectedFolderFiles?.length === 0}
                    onClick={onDeleteFiles}
                  >
                    <i className="icon-new-unlink f-14" />
                  </button>
                )}
              </div>
            )}
            <Row className="info-data-style">
              {(filesArray?.length > 0 || location?.state?.fileIds?.length > 0) &&
                filesArray?.map((item, i) => (
                  <DamFolderFileCard
                    key={item?._id}
                    item={item}
                    ind={i}
                    allSelectedFolderFiles={allSelectedFolderFiles}
                    onSelectCheckBox={onSelectCheckBox}
                    onDelete={onDeleteFiles}
                    t={t}
                  />
                ))}
            </Row>
          </>
        )}
      </Container>
      {showImageUpload && (
        <Modal className="common-custom-modal modal-large" show={showImageUpload} backdrop="static">
          <Modal.Header>
            <Modal.Title className="f-24">{t('SPEC_TEMP_LIBRARY.UPLOAD_IMAGE')}</Modal.Title>
            <span onClick={() => handleSubmitUpload('close')} className="icon-close cursor-pointer text-dark text-decoration-none" />
          </Modal.Header>

          <Modal.Body>
            <div className="modal-body">
              <ImgDropzone
                ref={childRef}
                title={t('DAM_FOLDER_VIEW.LISTING_VIEW.DIGITAL_ASSET_FOLDER')}
                onSubmit={handleSubmitUpload}
                image={damFolderData?.fullImage}
                acceptedFileExtenstion=".jpeg,.png,.jpg"
              />
            </div>
          </Modal.Body>
        </Modal>
      )}
      {showDeleteModal && (
        <ConfirmationPopup
          onOpen={showDeleteModal}
          onConfirm={() => confirmDeleteImage()}
          title={t('SPEC_TEMP_LIBRARY.REMOVE_IMAGE')}
          message={t('SPEC_TEMP_LIBRARY.REMOVE_MESSAGE')}
          toggle={() => closeModal()}
        />
      )}
      {deleteFilesStae && (
        <ConfirmationPopup
          onOpen={deleteFilesStae}
          onConfirm={() => deleteFolderFiles()}
          title={t('DAM_FOLDER_VIEW.LISTING_VIEW.REMOVE_FILES_MODAL_TITLE')}
          message={t('DAM_FOLDER_VIEW.LISTING_VIEW.REMOVE_FILES_MODAL_MSG')}
          toggle={() => closeDeletFileModal()}
        />
      )}
      {confirmModal && (
        <ConfirmationPopup
          onOpen={confirmModal}
          onConfirm={() => afterConfirmUnlink()}
          title={t('DAM_FOLDER_VIEW.LISTING_VIEW.UNLINK_TITLE')}
          message={
            seletedMultiKey === 'productType'
              ? t('DAM_FOLDER_VIEW.LISTING_VIEW.UNLINK_ASSET_CONFIRMATION_PRODUCTYPE')
              : t('DAM_FOLDER_VIEW.LISTING_VIEW.UNLINK_ASSET_CONFIRMATION_BRAND')
          }
          thirdMessage={t('DAM_FOLDER_VIEW.LISTING_VIEW.UNLINK_MESSAGE')}
          toggle={() => closeUnLinkConfirmModal()}
          showThirdMsg
        />
      )}
    </>
  );
}

export default AddEditDamFolderGroup;
